import { z } from "zod";

const httpUrl = z.string().regex(/^https?:\/\//i);

export const TournamentSchema = z.object({
  name: z.string().min(1),
  // The feed's own label, e.g. "TOURNAMENT - PICKLEBALL" — same eyebrow the
  // site shows.
  categoryLabel: z.string().default(""),
  venueName: z.string().default(""),
  location: z.string().default(""),
  // Pre-formatted on the agent side ("Sep 12 - Sep 13") — the raw calendar days
  // are deliberately not sent, because `new Date("2026-09-12")` in a US
  // timezone is Sep 11.
  dates: z.string().default(""),
  // Also pre-formatted ("$50.00"), by the same rules the site uses. Empty when
  // the feed carried no usable price; the card shows "Not listed".
  price: z.string().default(""),
  // Registration closes within CLOSING_SOON_DAYS (5, matching the site).
  closingSoon: z.boolean().default(false),
  distance: z.string().default(""),
  bannerUrl: httpUrl.nullable().optional(),
  url: httpUrl,
});

export const TournamentResultSchema = z.object({
  tournaments: z.array(TournamentSchema).min(1),
});

export type Tournament = z.infer<typeof TournamentSchema>;
export type TournamentResult = z.infer<typeof TournamentResultSchema>;

export function validateTournamentResult(value: unknown): TournamentResult | null {
  const parsed = TournamentResultSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
